import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import PublicPartners from "../components/layout/Partners/PublicPartners";
import "./Partners.css";
import { Loader } from "semantic-ui-react";

const Partners = (props) => {
  return (
    <>
      <div className="PartnersBackground">
        <div className="PartnersBannerBar"></div>
        <div className="PartnersContainer min-200">
          <h1>Our Valued Partners</h1>
          {props.partners && props.partners.length > 0 ? (
            props.partners.map(
              (e) =>
                e.order.length > 0 && (
                  <div className="PartnersSectionContainer">
                    <h3>{e.name}</h3>
                    <div className="PartnersContainerMain">
                      {e.order.map((partner) => (
                        <PublicPartners partner={partner} key={partner.id} />
                      ))}
                    </div>
                  </div>
                )
            )
          ) : (
            <div id="customLoader" style={{ padding: "15px" }}>
              <Loader size="large" active inline="centered" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const partners = state.firestore.data.partners || {};
  let partnersOrder = state.firestore.ordered.partnersOrder || [];

  if (partnersOrder && Object.keys(partners).length > 0) {
    partnersOrder = partnersOrder.map((e) => {
      let order = [...e?.order] || [];

      order = order.map((id) => partners[id]);
      return { ...e, order };
    });
  }
  return {
    partners: partnersOrder,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => {
    const firestoreArray = [
      {
        collection: "partners",
      },
      {
        collection: "partnersOrder",
        orderBy: ["modifiedAt", "desc"],
      },
    ];
    return firestoreArray;
  })
)(Partners);
